import { render, staticRenderFns } from "./fees-cost.vue?vue&type=template&id=5db118a9"
import script from "./fees-cost.vue?vue&type=script&lang=js"
export * from "./fees-cost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports